import { createFileRoute } from '@tanstack/react-router'
import ResetPassword from '@/pages/auth/reset-password'

export const Route = createFileRoute('/(auth)/reset-password')({
  component: ResetPassword,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: (search.token as string) || null,
      error: (search.error as string) || null,
    }
  },
})
